export default __webpack_public_path__ + "static/media/misc-makeupA-2048w.9139fe82.avif";